/**
 * 获取可用域名
 */ 
import { REQUESTDOMAIN, ENV, curProject } from 'CONFIG/config';
import request from 'UTILS/Axios.js';

/**
 * 获取可用域名
 * @param { Object } data, { env: <环境prod,env>, curProjectData: <总域名配置>, mainDomain: <全失败后主域>, timeout: <总超时时长|默认3000> }
 * return { Promise } string
 */
export function getRealDomain (data = {}) {
  let { env, curProjectData, mainDomain, timeout } = data;

  // 初始参数, TODO 变量处理
  env = env || ENV;
  curProjectData = curProjectData || curProject;
  mainDomain = mainDomain || REQUESTDOMAIN;
  timeout = timeout || 3000; // 总超时时间

  // 加载图片资源
  // 这里不设置超时和出错，只返回正确结果
  const imageLoader = function (imgData) {
    return new Promise((resolve, reject) => {
      let { id, icoURL } = imgData;
      let img = new Image();
      img.onload = () => {
        return resolve(imgData);
      }
      img.src = icoURL;
    });
  }

  // 获取可用的域名
  return new Promise(async (resolve) => {
    let promises = [];
    let timeStamp = new Date().getTime();
    // 备用域名列表
    let backupList = curProjectData[`APIBACKUP`] || [];
    // 现在的主域名
    backupList.unshift(mainDomain);

    // 如果只有一个域名，则返回
    if(backupList.length === 1){
      // 懒函数优化
      getRealDomain = () => {
        return mainDomain;
      };
      return resolve(mainDomain);
    }

    // 读取favicon.ico做为判断条件
    for(let i = 0; i < backupList.length; i++){
      let item = backupList[i];
      let imgData = {
        id: item, 
        icoURL: `${item}/favicon.ico?ver=${timeStamp}`
      };
      promises.push(imageLoader(imgData));
    }

    // 总超时时间，为了避免所有请求失败
    getRealDomain.timer = setTimeout(() => {
      // 懒函数优化
      getRealDomain = () => {
        return mainDomain;
      };
      resolve(mainDomain);
    }, timeout);

    // 获取最快的域名
    let data = await Promise.race(promises);
    clearTimeout(getRealDomain.timer);
    // 懒函数优化
    getRealDomain = () => {
      return data.id;
    };
    resolve(data.id);
  });
}

// 重写request方法，支持切换域名
export const apiRequest = async function (data, opts, customDomain) {
  let apiDomain = customDomain || await getRealDomain(Object.assign({}, {
    mainDomain: REQUESTDOMAIN
  }, opts || {}));
  // console.log(apiDomain);

  // 重写url
  data.url = `${apiDomain}/proxymsg`;
  return request(data);
};

export default apiRequest;
